import { render, staticRenderFns } from "./KAMGenericForm.vue?vue&type=template&id=1f64852f"
import script from "./KAMGenericForm.vue?vue&type=script&lang=ts"
export * from "./KAMGenericForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports